import { SettingType, SystemConfigKey } from 'src/type/settings';
import * as Yup from 'yup';

export const getSettingUpdated = (settings: SettingType[], key: SystemConfigKey) => {
  const setting = settings.find((s) => s.key === key);

  if (!setting?.approvedByUser) {
    return null;
  }

  return { user: setting.approvedByUser, updatedAt: setting.updatedAt };
};

export const getSettingValue = <T>(
  settings: SettingType[],
  key: SystemConfigKey
): T | undefined => {
  const setting = settings.find((s) => s.key === key);
  return setting?.value as T;
};

export const getSettingDescription = <T>(
  settings: SettingType[],
  key: SystemConfigKey
): T | undefined => {
  const setting = settings.find((s) => s.key === key);
  return setting?.description as T;
};

export const feeSchema = Yup.number()
  .typeError('ค่าธรรมเนียมต้องเป็นตัวเลข')
  .required('จำเป็นต้องระบุค่าธรรมเนียม')
  .moreThan(-1, 'จำนวนขั้นต่ำ 0');
// .lessThan(101, 'จำนวนต้องไม่เกิน 100');
